export const INPUT = 'input';
export const COLOUR = 'colour';
export const DROPDOWN = 'dropdown';
export const VIEW_LAYOUT = 'viewLayout';
export const BOOLEAN = 'boolean';
export const WEEK_PICKER = 'weekPicker';
export const SCENARIO_PICKER = 'scenarioPicker';
export const FIELD_TEXT = 'fieldText';
